import React from 'react';
import styled from 'styled-components';
import VitalsCarousel from '@components/VitalsCarousel';
import { PageSlice } from '@contracts';

interface Props {
  slice: PageSlice;
}

const VitalsSection: React.FC<Props> = ({ slice }) => {
  const articleIds = slice.primary.article_ids?.text;
  const hideControls = slice.primary.hide_controls;

  return (
    <Container>
      <VitalsCarousel articleIds={articleIds} hideControls={hideControls} />
    </Container>
  );
};

export default VitalsSection;

const Container = styled.div``;
